import { useContext } from 'react';
import { ModalContext } from '../modal.context';
import { ModalContextProps } from '../types';

const useModal = () => {
  const context = useContext<ModalContextProps>(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};

export default useModal;
